
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es_MX",
  "pt_BR",
  "zh_Hans",
  "zh_Hant"
]

export const localeLoaders = {
  "en": [],
  "de": [],
  "es_MX": [],
  "pt_BR": [],
  "zh_Hans": [],
  "zh_Hant": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute"
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "iso": "en"
    },
    {
      "code": "de",
      "language": "de-DE",
      "iso": "de"
    },
    {
      "code": "es_MX",
      "language": "es-MX",
      "iso": "es"
    },
    {
      "code": "pt_BR",
      "language": "pt-BR",
      "iso": "pt-BR"
    },
    {
      "code": "zh_Hans",
      "language": "zh-Hans",
      "iso": "zh-CN",
      "alias": [
        "zh-CN",
        "zh-SG",
        "zh"
      ]
    },
    {
      "code": "zh_Hant",
      "language": "zh-Hant",
      "iso": "zh-HK",
      "alias": [
        "zh-HK",
        "zh-TW",
        "zh-MO"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "precompile": {
    "strictMessage": false,
    "escapeHtml": true
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "iso": "en",
    "files": []
  },
  {
    "code": "de",
    "language": "de-DE",
    "iso": "de",
    "files": []
  },
  {
    "code": "es_MX",
    "language": "es-MX",
    "iso": "es",
    "files": []
  },
  {
    "code": "pt_BR",
    "language": "pt-BR",
    "iso": "pt-BR",
    "files": []
  },
  {
    "code": "zh_Hans",
    "language": "zh-Hans",
    "iso": "zh-CN",
    "alias": [
      "zh-CN",
      "zh-SG",
      "zh"
    ],
    "files": []
  },
  {
    "code": "zh_Hant",
    "language": "zh-Hant",
    "iso": "zh-HK",
    "alias": [
      "zh-HK",
      "zh-TW",
      "zh-MO"
    ],
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
